// src/request/api/dict/updateUpgrade.ts

import {UpdateWeaponUpgradeDto, WeaponUpgradeFullDto} from "../../../../model/Dto/Dict/WeaponUpgrade";
import {ApiRequest, RequestMethod} from "../../../request";

export async function updateUpgrade(
    id: string,
    data: UpdateWeaponUpgradeDto
): Promise<WeaponUpgradeFullDto | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/weapon-upgrade/${id}`);
    apiRequest.setJsonBody(data);

    const response: any = await apiRequest.send();

    if (response.status === 200) {
        return {
            id: response.data["id"],
            name: response.data["name"],
            description: response.data["description"],
            price: response.data["price"],
            rarity: response.data["rarity"],
            prices: response.data["prices"] ? {
                firstCategory: response.data["prices"]["firstCategory"],
                secondCategory: response.data["prices"]["secondCategory"],
                thirdCategory: response.data["prices"]["thirdCategory"],
                fourthCategory: response.data["prices"]["fourthCategory"],
                fifthCategory: response.data["prices"]["fifthCategory"],
            } : null,
            enum: response.data["enum"],
            commonStatus: response.data["commonStatus"],
        };
    }

    return null;
}